import { canAccessWorkspace } from '@core/utils/can-access-workspace'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceId')({
  beforeLoad: async ({ context: { queryClient }, params: { workspaceId } }) => {
    if (!(await canAccessWorkspace(queryClient, workspaceId)))
      throw redirect({ to: ROUTES.root })
  },
})
